import { render } from "./vertical-menu.vue?vue&type=template&id=a239cbbc&scoped=true&ts=true"
import script from "./vertical-menu.vue?vue&type=script&lang=ts"
export * from "./vertical-menu.vue?vue&type=script&lang=ts"

import "./vertical-menu.vue?vue&type=style&index=0&id=a239cbbc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a239cbbc"]])

export default __exports__